import { useEffect, useState } from "react";

import GeneratedRecord from "../../models/generated-record";
import { getItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";

interface ProductAsyncImageProps {
  record: GeneratedRecord;
}

const PLACEHOLDER_URL = "/image_not_found.jpg";
const RecordAsyncImage: React.FC<ProductAsyncImageProps> = ({ record }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);

  const loadImage = async (record: GeneratedRecord) => {
    const presignedUrlState = await getItem<{ url: string }>(
      `/records/${record.id}/qr_url/`
    );

    if (
      presignedUrlState.status !== SUCCESS ||
      presignedUrlState.data === undefined
    ) {
      setLoading(false);
      return;
    }
    setImageUrl(presignedUrlState.data.url);
    setLoading(false);
  };

  useEffect(() => {
    loadImage(record);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading || imageUrl === undefined) {
    return (
      <img
        src={PLACEHOLDER_URL}
        alt="logo"
        style={{ maxHeight: "100px", width: "auto" }}
      />
    );
  }

  return (
    <img
      src={imageUrl}
      alt="logo"
      style={{ maxHeight: "100px", width: "auto" }}
    />
  );
};

export default RecordAsyncImage;
